'use strict';

angular.module('docketbook').
  controller('lineItemModalController', function(userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {

    $scope.orderEditing = null;

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.newLineItemFromParent = function(order, cb) {
      $scope.lineItemCallback = cb;
      $scope.lineItemDetail = {};
      $scope.lineItemDetail.quantityEdit = 0;
      $scope.orderEditing = order;
      if ( userService.userCanDoAction('isOrderSupplier', order) ) {
        $scope.selectResource();
        $scope.lineItemDetail.customerCreated = false;
      } else {
        $scope.lineItemDetail.customerCreated = true;
        $("#lineItemModal").fadeIn(100);
      }

      //$("#lineItemModal").fadeIn(100);
    }

    $scope.$parent.editLineItemFromParent = function(order, item, cb) {
      $scope.lineItemCallback = cb;
      $scope.lineItemDetail = item;
      $scope.orderEditing = order;

      $("#lineItemModal").fadeIn(100);
    }

    /*******************************/
    /***** Line Item Functions *****/
    /*******************************/

    $scope.closeLineItemModal = function() {
      $("#lineItemModal").fadeOut(100);
      $scope.lineItemCallback(null);
    }

    $scope.selectResource = function() {
      $("#lineItemModal").fadeOut(100);
      $scope.$parent.selectResourceForLine(function(resourceSelected) {
        if ( resourceSelected == null ) {
          $scope.lineItemCallback();
        } else {
          $scope.lineItemDetail.resource = resourceSelected;
          $("#lineItemModal").fadeIn(100);
        }
      });
    }

    $scope.saveLineItem = function() {
      $("#lineItemModal").fadeOut(100);
      $scope.lineItemCallback($scope.lineItemDetail);
    }

    /***************************************/
    /***** Quantity Edit Functionality *****/
    /***************************************/

    // Mobile only - edit line item quantity
    $scope.editLineItemQuantity = function(lineItemDetail) {
      $("#lineItemModal").fadeOut(100);
      //$("#quantityKeypadModal").fadeIn(100);
      $scope.quantityKeypadValue = angular.copy(lineItemDetail.quantityEdit);
      $scope.quantityKeypadUom = lineItemDetail.resource.uom;
    }

    $scope.closeQuantityEditModal = function() {
      //$("#quantityKeypadModal").fadeOut(100);
      $("#lineItemModal").fadeIn(100);
    }

    $scope.saveQuantityEdit = function() {
      var newValueFloat = parseFloat($scope.quantityKeypadValue);
      $scope.lineItemDetail.quantityEdit = newValueFloat;
      $scope.closeQuantityEditModal();
    }

    $scope.keypadButtonPress = function(buttonValue) {
      if ( $scope.quantityKeypadValue == null ) {
        $scope.quantityKeypadValue = 0;
      }

      var currentValString = $scope.quantityKeypadValue.toString();

      if ( buttonValue == '.' ) {
        currentValString += ".";
      } else if ( buttonValue == 'back' ) {
        if ( currentValString.length > 1 ) {
          currentValString = currentValString.substring(0, currentValString.length - 1);
        } else if ( currentValString.length == 1 ) {
          currentValString = "0";
        }
      } else {
        if ( currentValString == "0" ) {
          currentValString = buttonValue.toString();
        } else {
          currentValString += buttonValue.toString();
        }
      }

      $scope.quantityKeypadValue = currentValString;
    }
});



// WEBPACK FOOTER //
// ./src/controllers/modals/lineItemModalController.js